import { BaseApi } from './base.api.js';

export class BcmSettingsApi extends BaseApi {
    constructor(client) {
        super(client, '/bcm-settings');
    }
}
